"use client"
import { useLanguage } from "../contexts/LanguageContext"

const About = () => {
  const { t, language } = useLanguage()
  
  // Add RTL class when language is Hebrew
  const aboutClass = language === 'he' ? 'rtl-text' : ''

  return (
    <section id="about" className={`about ${aboutClass}`} itemScope itemType="https://schema.org/Organization">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="about-title" itemProp="name">{t("aboutTitle")}</h2>
            <p className="about-description" itemProp="description">{t("aboutText1")}</p>
            <p className="about-description">{t("aboutText2")}</p>
            <p className="about-description">{t("aboutText3")}</p>
            
            <h3 className="vision-title">{t("visionTitle")}</h3>
            <p className="about-description">{t("visionText")}</p>
          </div>
          <div className="about-image">
            <img src="https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569958/Logo_b6xvr2.png" alt="Gold House - דירות יוקרה להשכרה" itemProp="logo" />
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
